import UnauthorizedUserIcon from "../../assets/common/unauthorized-icon.svg";
import "../../styles/common.css";

interface UnauthorizedAccessProps {
  title: string;
  message: string;
  onClick: () => void;
}
const UnauthorizedAccess = ({
  title,
  message,
  onClick,
}: UnauthorizedAccessProps) => {
  return (
    <>
      <div className="unauthorized-container">
        <img src={UnauthorizedUserIcon} alt="UnAuthorized User" className="unauthorized-image" />
        <h1 className="unauthorized-title base-text">{title}</h1>
        <h1 className="unauthorized-message base-text">{message}</h1>
        <button onClick={onClick} className="unauthorized-button base-text">Go Back</button>
      </div>
    </>
  );
};

export default UnauthorizedAccess;
